import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-32" data-mp="3h0z2wwv6xgxl">
      <div className="animate-pulse-red flex h-16 w-16 items-center justify-center rounded-xl border border-red/60 font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-33" data-mp="3h2a913c3z0rv">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-34" data-mp="10btlzpmvx2s3">
        {label}
      </span>
    </div>;
}
type Props = {
  spotsTaken?: number;
};
export function Countdown({
  spotsTaken = 68
}: Props) {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 26);
  return <section aria-label="Countdown" className="relative w-full overflow-x-hidden bg-ink" data-id="element-35" data-mp="t124fk15vb0h">
      <div className="mx-auto max-w-3xl px-5 py-8 text-center" data-id="element-36" data-mp="17r9dxa96xjp1">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" style={{
        color: "#E11D2B"
      }} data-id="element-37" data-mp="12rwqooeeqalx">
          ⏰ Launch price — closes in:
        </p>

        <div className="relative mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-38" data-mp="f2ualkzf8ptj">
          <div className="animate-glow-red pointer-events-none absolute inset-y-[-25%] left-1/2 w-[min(16rem,80%)] -translate-x-1/2 rounded-full bg-red/40 blur-2xl" aria-hidden="true" data-id="element-39" data-mp="a4j0ra94mfbb" />
          <Unit value={hh} label="Hours" data-id="element-40" data-mp="k03vqofs2fbk" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="1zhvyuhqnb73z">:</span>
          <Unit value={mm} label="Min" data-id="element-42" data-mp="1vgkhezhxds6v" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-43" data-mp="1vfitvvjq3d89">:</span>
          <Unit value={ss} label="Sec" data-id="element-44" data-mp="s66cdjsegq9b" />
        </div>

        <p className="mt-6 text-sm font-semibold text-white/60" style={{
        color: "#FFFFFF"
      }} data-id="element-45" data-mp="s7r7baimmb7p">
          ⚠️ Then it goes up to $50. This price will not return.
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-46" data-mp="1255lt4kzopxd">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-47" data-mp="165fp29hed28j">
            🔴 Launch price spots
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-48" data-mp="9fydjdvqglyx">
            <div className="h-full rounded-full bg-red" style={{
            width: `${spotsTaken}%`
          }} data-id="element-49" data-mp="ee05ypf1txn2" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-red-soft" data-id="element-50" data-mp="ifbmm5fy38j4">
            {spotsTaken}% taken — Very few remaining
          </p>
        </div>
      </div>
    </section>;
}